const lineBreakExpression = /\r\n?/g

export function normalizeMarkdown(raw: string) {
  return raw.replace(/^\uFEFF/, '').replace(lineBreakExpression, '\n').trimEnd()
}

export function deriveDocumentName(markdown: string, fallback = 'Untitled note') {
  const headingMatch = markdown.match(/^#\s+(.+)$/m)
  if (headingMatch?.[1]) {
    return headingMatch[1].trim()
  }

  const firstLine = markdown
    .split('\n')
    .map((line) => line.trim())
    .find(Boolean)

  if (!firstLine) {
    return fallback
  }

  return firstLine.length > 48 ? `${firstLine.slice(0, 45).trimEnd()}...` : firstLine
}

export function isMarkdownFile(file: File) {
  return (
    file.type === 'text/markdown' ||
    file.type === 'text/plain' ||
    /\.(md|markdown|txt)$/i.test(file.name)
  )
}
